<template>
  <span data-test="s-date" name="date" v-if="dateIsValid">
    {{ formattedDate }}
  </span>
  <span v-else>
    {{ date }}
  </span>
</template>

<script>
/**
 * Sofy date component
 *
 * @component admin/common/components/s-date
 * @vueprop {Date | String} [date] Define date
 */
import moment from 'moment-timezone';
import { mapState } from 'vuex';

export default {
  props: {
    date: { type: [Date, String] },
    formatString: { type: String },
    includeTime: { type: Boolean, default: true },
    keepUtc: { type: Boolean, default: false }
  },

  computed: {
    ...mapState('user-login', ['user']),

    /**
     * Format date according to given format or user's date-time format.
     * Default format [DD/MM/YYYY HH:mm:SS]
     */
    formattedDate() {
      if (this.formatString) {
        return moment(this.date).format(this.formatString);
      }
      if (!this.includeTime) {
        let format = this.user.dateFormat || 'DD/MM/YYYY HH:mm:SS';
        let match = format.match(/HH|hh|H|h/);
        if (match) {
          format = format.substring(0, match.index - 1);
        }
        return this.keepUtc ? moment.utc(this.date).format(format) : moment(this.date).format(format);
      }
      if (this.keepUtc) {
        return moment.utc(this.date).format();
      }
      return moment(this.date).format();
    },

    dateIsValid() {
      let origDate = new Date(this.date);
      return !isNaN(origDate.getTime()) && origDate.getTime() > 0;
    }
  }
};
</script>
